import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const candidateJobService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    softDelete,
    destroy,
    uploadImage,
};

const MODULE = {
    CANDIDATE_JOB: 'candidate-jobs',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            company_uuid: filter?.companyUUID,
            department_uuid: filter?.departmentUUID,
            office_uuid: filter?.officeUUID,
            is_intern: filter?.isIntern,
            is_fresh_graduate: filter?.isFreshGraduate,
            is_published: filter?.isPublished,
            is_active: filter?.isActive,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.CANDIDATE_JOB}`, request);
}

export function store (data) {
    const request = {
        company_uuid: data.companyUUID,
        department_uuid: data.departmentUUID,
        office_uuid: data.officeUUID,
        name: data.name,
        location: data.location,
        openings: data.openings,
        allowance: data.allowance,
        min_salary: data.minSalary,
        max_salary: data.maxSalary,
        closing_date: data.closingDate,
        description: data.description,
        tags: (data.tags ?? []).filter(item => item),
        is_intern: data.isIntern,
        is_fresh_graduate: data.isFreshGraduate,
        is_published: data.isPublished,
    };

    return apiHelper(API_URL).post(`/${MODULE.CANDIDATE_JOB}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.CANDIDATE_JOB}/${uuid}`);
}

export function update (data) {
    const request = {
        company_uuid: data.companyUUID,
        department_uuid: data.departmentUUID,
        office_uuid: data.officeUUID,
        name: data.name,
        location: data.location,
        openings: data.openings,
        allowance: data.allowance,
        min_salary: data.minSalary,
        max_salary: data.maxSalary,
        closing_date: data.closingDate,
        description: data.description,
        tags: (data.tags ?? []).filter(item => item),
        is_intern: data.isIntern,
        is_fresh_graduate: data.isFreshGraduate,
        is_published: data.isPublished,
    };

    return apiHelper(API_URL).put(`/${MODULE.CANDIDATE_JOB}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.CANDIDATE_JOB}/status/${data.uuid}`, request);
}

export function softDelete (data) {
    return apiHelper(API_URL).patch(`/${MODULE.CANDIDATE_JOB}/delete/${data.uuid}`);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.CANDIDATE_JOB}/${data.uuid}`);
}

export function uploadImage (data) {
    const formData = new FormData();
    if (data.file instanceof File) formData.append(`upload`, data.file);

    return apiHelper(API_URL).post(`/${MODULE.CANDIDATE_JOB}/image-uploads`, formData);
}
